// VE SAT API
/* global ve */
import {
  decodeJwt,
  doLog,
  getVeEnvLocSatApiBaseURI,
  getVeEnvLoc,
  getVeEnvLocFromUrl,
  redirectToLogin,
  isAccessTokenExpired,
  hasProp,
  jsonSize
} from './veb.js'
import vecfg from './vecfg.js'

// Following block of code is a monkey-patch to intercept the http requests/api call
const { fetch: originalFetch } = window
window.originalFetch = originalFetch
window.fetch = async (...args) => {
  const fn = 'api:fetch'
  const dbg = false // true
  const [path, config, context] = args
  doLog(fn, { path, config, currentSecurityContext: context }, dbg)
  const response = await originalFetch(path, config)
  doLog(fn, { response }, dbg)
  // response interceptor start
  if (context && !config.headers['x-sat-allowed-security-context']) {
    const value = response.headers.get('x-sat-allowed-security-context')
    const owner = context.split('/')[0]
    const ownerDocClass = `${owner}/${context.split('/')[1]}`
    let queryType = path.split('/').slice(-1)[0]
    const index = queryType.indexOf('?')
    queryType = queryType.substring(0, index !== -1 ? index : queryType.length)
    if (window.sessionStorage.getItem(owner) !== null) {
      const item = JSON.parse(window.sessionStorage.getItem(owner))
      if (!item[ownerDocClass]) item[ownerDocClass] = {}
      item[ownerDocClass][queryType] = value
      window.sessionStorage.removeItem(owner)
      window.sessionStorage.setItem(owner, JSON.stringify(item))
    } else {
      const newObject = {
        [ownerDocClass]: {
          [queryType]: value
        }
      }
      window.sessionStorage.setItem(owner, JSON.stringify(newObject))
    }
  }
  // response interceptor end
  return response
}
const fn = 'api'
const debug = false // todo: remove, use dbg
const dbg = false // todo: add function to set true/false
let veAuthUrl
let veCommonUrl

if (process.env.NODE_ENV === 'dev' || process.env.NODE_ENV === 'test') {
  veAuthUrl = 'http://localhost:3000/ve-sat-api/ve-auth/'
  veCommonUrl = 'http://localhost:3000/ve-sat-api/common/'
} else {
  veAuthUrl = baseURL()
  let [scheme, domain] = veAuthUrl.split('//')
  domain = domain.split('/')[0]
  veAuthUrl = `${scheme}//${domain.trim('/')}/sat/ve-auth/`
  veCommonUrl = `${scheme}//${domain.trim('/')}/sat/common/`
  doLog(fn, { veAuthUrl, veCommonUrl }, dbg)
}

function baseURL () {
  const fn = 'api:baseURL'
  let veEnvLoc = 've-cd-dev-in-1' // default for localhost
  try {
    veEnvLoc = getVeEnvLoc(debug)
    if (typeof veEnvLoc !== 'string') {
      veEnvLoc = getVeEnvLocFromUrl(vecfg, debug)
      if (typeof veEnvLoc === 'string') { window.sessionStorage.setItem('veEnvLoc', veEnvLoc) }
    }
  } catch (e) {
    veEnvLoc = 've-cd-dev-in-1'
  }
  if (typeof veEnvLoc !== 'string' || veEnvLoc === 'veEnvLoc') {
    veEnvLoc = 've-cd-dev-in-1'
    window.sessionStorage.setItem('veEnvLoc', veEnvLoc)
    doLog(fn, { veEnvLoc, typeofVeEnvLoc: typeof veEnvLoc }, dbg)
  }
  return getVeEnvLocSatApiBaseURI(vecfg, veEnvLoc, dbg)
}

export default {
  baseURL,

  async accessToken () {
    return await ve.amplify.getAmplifyAccessToken(dbg)
  },

  async preCheck (path) {
    const fn = 'api:preCheck'
    // doLog(fn, { path, typeofPath: typeof path }, true)
    if (!this.baseURL()) {
      const error = new Error()
      error.code = 'pre check error'
      error.message = 'Base URL not set'
      throw error
    }
    if (path.includes('/auth/refreshdvijwt')) return
    if (!await this.accessToken()) {
      const error = new Error()
      error.code = 'pre check error'
      error.message = 'No access token'
      doLog(fn, { error }, true)
      redirectToLogin()
      // throw error
    }
    if (await isAccessTokenExpired()) {
      const error = new Error()
      error.code = 'pre check error'
      error.message = 'access token expired'
      doLog(fn, { info: 'accesstoken expired', error }, true)
      throw error
    }
  },

  checkAndValidateJwt (currentSecurityContext, path, dbg = false) {
    const fn = 'checkAndValidateJwt'
    dbg = false
    const owner = currentSecurityContext.split('/')[0]
    const ownerDocClass = `${owner}/${currentSecurityContext.split('/')[1]}`
    let queryType = path.split('/').slice(-1)[0]
    const index = queryType.indexOf('?')
    queryType = queryType.substring(0, index !== -1 ? index : queryType.length)
    doLog(fn, { ownerDocClass, queryType }, dbg)
    let token = null
    if (window.sessionStorage.getItem(owner) !== null) {
      const item = JSON.parse(window.sessionStorage.getItem(owner))
      doLog(fn, { item }, dbg)
      if (item[ownerDocClass] && item[ownerDocClass][queryType] !== null) {
        token = item[ownerDocClass][queryType]
      }
    }
    doLog(fn, { token }, dbg)
    if (token && this.isValidJwt(token, ownerDocClass, dbg)) {
      return token
    }
    return null
  },

  isValidJwt (token, currentContext, dbg = false) {
    const fn = 'isValidJwt'
    dbg = false
    const dt = decodeJwt(token, dbg)
    const currentDate = new Date()
    const currentSeconds = Math.round(currentDate.getTime() / 1000)
    doLog(fn, { currentContext, currentSeconds }, dbg)
    const isValid = (dt.allowedSecurityContexts.includes(currentContext) || dt.allowedSecurityContexts.includes(`${currentContext}/`)) && dt.exp >= currentSeconds
    doLog(fn, { isValid }, debug)
    return isValid
  },

  ensureSecurityContext (qsObj) {
    // handle sc instead of securityContext
    const { securityContext, sc } = qsObj
    if (sc && !securityContext) qsObj.securityContext = sc
    delete qsObj.sc
    return qsObj
  },

  sanitiseSecurityContextInBody (body) {
    // handle sc instead of securityContext
    if (!body) return body
    const { securityContext, sc } = body
    if (sc && !securityContext) body.securityContext = sc
    delete body.sc
    if (typeof body !== 'string') body = JSON.stringify(body)
    return body
  },

  async getHeaders (dbg = false) {
    const headers = { 'Content-Type': 'application/json' }
    const token = await this.accessToken()
    if (token) { headers.Authorization = 'Bearer ' + token }
    if (dbg) headers['x-sat-api-debug'] = dbg
    return headers
  },

  async getHeaders2 (context, path, dbg = false) {
    // const fn = 'api:getHeaders2'
    let securityContextToken = ''
    const headers = { 'Content-Type': 'application/json', 'x-sat-allowed-security-context': null }
    headers['accept-language'] = 'en'
    if (dbg) headers['x-sat-api-debug'] = dbg
    if (context) {
      securityContextToken = this.checkAndValidateJwt(context, path, dbg)
      // doLog(fn, { securityContextToken }, dbg)
      if (securityContextToken) { headers['x-sat-allowed-security-context'] = 'Bearer ' + securityContextToken }
    }
    const token = await this.accessToken()
    if (token) headers.Authorization = 'Bearer ' + token
    return headers
  },

  async get (path, params = {}, context, limit, exclusiveStartKey, dbg = false) {
    // original API
    await this.preCheck(path)
    if (context) params.context = context
    if (limit) params.limit = limit
    if (exclusiveStartKey) { params.exclusiveStartKey = JSON.stringify(exclusiveStartKey) }
    const querystring = new URLSearchParams(params)
    const url = `${this.baseURL()}${path}?${querystring}`
    try {
      const response = await window.fetch(url, { method: 'GET', headers: await this.getHeaders(dbg) })
      return await this.handleSATAPIFetchResponse(response)
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async get2 (path, qsObj, dbg = false) { // veAuth API
    // const fn = 'api:get2'
    // doLog(fn, { path, qsObj }, dbg)
    // doLog(fn, { veAuthUrl }, dbg)
    let url = `${veAuthUrl}${path}?`
    // adjust url for context-selector
    url = url.replace('/sat/ve-auth/context-selector/', '/sat/context-selector/')
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    // doLog(fn, { url }, dbg)
    try {
      const { securityContext: sc } = qsObj
      const params = { method: 'GET', headers: await this.getHeaders2(sc, url, dbg) }
      const res = await window.fetch(url, params, sc)
      return await this.handleSATAPIFetchResponse(res)
    } catch (e) {
      console.log(e)
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async get3 (path, qsObj = {}, dbg = false) { // common API
    // const fn = 'api:get3'
    // doLog(fn, { path, qsObj }, dbg)
    // doLog(fn, { veCommonUrl }, dbg)
    let url = `${veCommonUrl}${path}?`
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    try {
      const { securityContext: sc } = qsObj
      const params = { method: 'GET', headers: await this.getHeaders2(sc, url, debug) }
      const response = await window.fetch(url, params, sc)
      return await this.handleSATAPIFetchResponse(response)
    } catch (e) {
      console.log(e)
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async put3 (path, qsObj = {}, body, dbg = false) { // common API
    // const fn = 'api:put3'
    // doLog(fn, { path, qsObj }, dbg)
    // doLog(fn, { veCommonUrl }, dbg)
    let url = `${veCommonUrl}${path}?`
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    try {
      body = this.sanitiseSecurityContextInBody(body)
      const params = { method: 'PUT', headers: await this.getHeaders(dbg), body }
      // doLog(fn, { headersSize: `${jsonSize(params.headers)}kB`, bodySize: `${jsonSize(params.body)}kB` }, dbg)
      // doLog(fn, { urlSize: `${url.length}`, paramsSize: `${jsonSize(params)}kB` }, dbg)
      const response = await window.fetch(url, params, null)
      if (response.ok) return await response.json()
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async post2 (path, qsObj, body, dbg = false) { // veAuth API
    const fn = 'api:post2'
    doLog(fn, { path, qsObj }, dbg)
    let url = `${veAuthUrl}${path}?`
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    doLog(fn, { url }, dbg)
    try {
      const { securityContext: sc } = qsObj
      body = this.sanitiseSecurityContextInBody(body)
      const params = { method: 'POST', headers: await this.getHeaders2(sc, url, dbg), body }
      doLog(fn, { paramsSize: `${jsonSize(params)}kB` }, dbg)
      const res = await window.fetch(url, params, sc)
      doLog(fn, { res }, debug)
      return await this.handleSATAPIFetchResponse(res)
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async put2 (path, qsObj, body, dbg = false) { // veAuth API
    const fn = 'api:put2'
    let url = `${veAuthUrl}${path}?`
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    try {
      const { securityContext: sc } = qsObj
      body = this.sanitiseSecurityContextInBody(body)
      const params = { method: 'PUT', headers: await this.getHeaders2(sc, url, dbg), body }
      doLog(fn, { headersSize: `${jsonSize(params.headers)}kB`, bodySize: `${jsonSize(params.body)}kB` }, dbg)
      doLog(fn, { urlSize: url.length, paramsSize: `${jsonSize(params)}kB` }, dbg)
      const res = await window.fetch(url, params, sc)
      if (res.ok) return await res.json()
      else return await this.handleSATAPIFetchResponse(res)
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async delete2 (path, qsObj, body, debug = true) { // veAuth API
    const fn = 'api:delete2'
    let url = `${veAuthUrl}${path}?`
    qsObj = this.ensureSecurityContext(qsObj)
    url = url + new URLSearchParams(qsObj)
    try {
      const { securityContext: sc } = qsObj
      body = this.sanitiseSecurityContextInBody(body)
      const params = { method: 'DELETE', headers: await this.getHeaders2(sc, url, dbg), body }
      doLog(fn, { paramsSize: `${jsonSize(params)}kB` }, dbg)
      const res = await window.fetch(url, params, sc)
      if (res.ok) return await res.json()
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async put (path, params = {}, body, dbg = false) { // original API
    return await this.post(path, params, body, 'PUT', dbg)
  },

  async post (path, params = {}, body, method = 'POST', dbg = false) { // original API
    await this.preCheck(path)
    const querystring = new URLSearchParams(params)
    const url = `${this.baseURL()}${path}?${querystring}`
    try {
      const params = { method, headers: await this.getHeaders(dbg), body: JSON.stringify(body) }
      const res = await window.fetch(url, params)
      return await this.handleSATAPIFetchResponse(res)
    } catch (e) {
      await this.handleSATAPIFetchError(e, url)
    }
  },

  async handleSATAPIFetchError (error, url) {
    const fn = 'handleSATAPIFetchError'
    // {"message":"Access token expired","code":"AccessTokenExpired","status":401}
    const dbg = true
    doLog(fn, { url, error }, dbg)
    const errorStatus = hasProp(error, 'status') ? error.status : 0
    // default error
    const err = new Error()
    err.message = ''
    err.code = 'ServerError'
    err.status = errorStatus
    // e.g. 401 is access token expired error returning JSON { code: , message: , status }
    if (errorStatus >= 400) {
      try {
        err.code = error.code
        err.message = error.message
        err.data = error.data || 'no-error-data'
      } catch (e) {
        err.message += ` (${JSON.stringify(e)})`
      }
    } else {
      doLog(fn, { info: 'no error.status' }, dbg)
    }
    throw err
  },

  async handleSATAPIFetchResponse (res) {
    const fn = 'api:handleSATAPIFetchResponse'
    // Success - return JSON
    if (res.ok) return await res.json()
    doLog(fn, { res }, dbg)
    // Failed
    const error = new Error()
    error.message = res.status + ' ' + res.statusText + ' for ' + res.url
    error.code = 'ServerError'
    error.status = res.status
    // 4xx are API business logic errors that should return JSON {code: , message: , data: {errors: []}}
    if (res.status >= 400 && res.status < 500) {
      try {
        const json = await res.json()
        error.code = json.code
        error.message = json.message
        error.data = json.data
      } catch (e) {
        error.message += ` (${JSON.stringify(e)})`
      }
    }
    throw error
  }
}
